import { fetchActiveCountry } from "../Country/action";
import { fetchDiseaseAction } from "../Disease/action";
import { fetchDonationSummaryAction, fetchCountryDonationSummaryAction } from "../Donation/action";
import { fetchAppStateService } from './api';
import { toast } from 'react-toastify';
import { SETUP_APP, SETUP_APP_COMPLETE, APP_STATE } from "./types";


let count = 0;
export const fetchAppState = async (dispatch) => {
  try {
    const response = await fetchAppStateService({
      designation: "app",
    })();
    dispatch({ type: APP_STATE, state: response?.data });
  } catch (error) {
    if (count === 2) {
      return
    }
    setTimeout(() => {
      dispatch(fetchAppState);
      count = count += 1
    }, 500);
  }
};

export const setupApplication = (
  countryDispatch,
  diseaseDispatch,
  donationDispatch
) => async (dispatch) => {
  try {

    dispatch({ type: SETUP_APP });
    await dispatch(fetchAppState);
    await diseaseDispatch(fetchDiseaseAction());
    await countryDispatch(fetchActiveCountry());
    await donationDispatch(fetchDonationSummaryAction());
    await donationDispatch(fetchCountryDonationSummaryAction());
    dispatch({ type: SETUP_APP_COMPLETE });
  } catch (error) {
    dispatch({ type: SETUP_APP_COMPLETE });
  }
};
